import { render, staticRenderFns } from "./AUBEGuideModule.vue?vue&type=template&id=54d2798e&scoped=true&"
import script from "./AUBEGuideModule.vue?vue&type=script&lang=js&"
export * from "./AUBEGuideModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2798e",
  null
  
)

export default component.exports